<div class="toilet"
     [style.background-image]="statesService.backgroundImageSrc + statesService.imageNumber + '.webp)'">
</div>
